import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EventManagement from './admin/EventManagement_new';
import UserManagement from './admin/UserManagement';
import CouponManagement from './admin/CouponManagement';
import Statistics from './admin/Statistics';
import ParticipantsList from './admin/ParticipantsList';

const AdminPanel = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('events');

  return (
    <div className="container mt-4">
      {/* Navigation Header */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
           
            <div className="d-flex align-items-center">
              <span className="me-3">
                <strong>{user.username}</strong> - {user.points} Punkte
              </span>
              <button
                className="btn btn-outline-danger"
                onClick={onLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="mb-0">🛠️ Admin Panel</h4>
              <small className="text-muted">Verwaltung des Event Systems</small>
            </div>
            <div className="card-body">
              {/* Tab Navigation */}
              <ul className="nav nav-tabs mb-3">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'events' ? 'active' : ''}`}
                    onClick={() => setActiveTab('events')}
                  >
                    📅 Events
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'users' ? 'active' : ''}`}
                    onClick={() => setActiveTab('users')}
                  >
                    👥 Benutzer
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'coupons' ? 'active' : ''}`}
                    onClick={() => setActiveTab('coupons')}
                  >
                    🎟️ Gutscheine
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'stats' ? 'active' : ''}`}
                    onClick={() => setActiveTab('stats')}
                  >
                    📊 Statistiken
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'participants' ? 'active' : ''}`}
                    onClick={() => setActiveTab('participants')}
                  >
                    👥 Teilnehmer
                  </button>
                </li>
              </ul>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === 'events' && <EventManagement />}
                {activeTab === 'users' && <UserManagement />}
                {activeTab === 'coupons' && <CouponManagement />}
                {activeTab === 'stats' && <Statistics />}
                {activeTab === 'participants' && <ParticipantsList />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
